import Login from './login-container';

export default Login;


// WEBPACK FOOTER //
// ./src/route/login/index.js